import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';
// import ExamStore from './ExamStore';

var obx = observable({
  threads: [],
  // Get all message threads
  getThreads: action(function() {
    SessionStore.startLoading('Loading…', 'GetThreads');

    // Temporarily hardcoded install sid. Probably will drop the install from the endpoint
    api.get(`/messages?userSid=${SessionStore.userData.sid}`)
      .then(response => {
        obx.threads = response.data.results;
        SessionStore.finishLoading('GetThreads');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get thread ID
  activeThread: {},
  getThreadId: action(function(toUserSid, contextType, contextId) {
    obx.activeThread = {};

    api.get(`/messages?userSid=${SessionStore.userData.sid}`)
      .then(response => {
        let threadId = null;

        // Filter the result by recipient, context type (e.g. examSid), and context id
        const existingThread = response.data.results.filter(function(thread){
          if(contextType === 'courseSid') {
            return thread.courseSid === contextId &&
                   thread.examConfiguration === null &&
                   thread.examSessionEventReport === null &&
                   thread.examSid === null &&
                   thread.proctorApproval === null;
          } else {
            return thread[contextType] === contextId;
          }
        });

        if(existingThread.length > 0) {
          threadId = existingThread[0].sid;
          obx.activeThread = existingThread[0];
        }

        if(threadId) {
          // Get the actual thread
          obx.getThread(threadId);
        } else {
          // Otherwise if no thread matches, reset the thread message array
          obx.threadMessages = [];
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get an individual thread
  threadMessages: [],
  threadObject: {},
  getThread: action(function(sid, forceScroll) {
    obx.threadMessages = [];

    SessionStore.startBackgroundLoading('GetThread');

    api.get(`/messages/${sid}?includeItems=true`)
      .then(response => {
        obx.threadMessages = response.data.items;
        obx.threadObject = response.data;

        // // If there’s a configuration sid, get that data
        // if(response.data.examConfigurationSid) {
        //   ExamStore.getConfigurationData(response.data.examSid, response.data.examConfigurationSid);
        // }

        // // If there’s an exam sid, get that data
        // if(response.data.examSid) {
        //   ExamStore.getExam(response.data.examSid);
        // }

        SessionStore.finishBackgroundLoading('GetThread');

        // If we want the thread scrolled to the bottom
        if(forceScroll) {
          setTimeout(function(){
            const drawer = document.querySelector('.drawer');
            const inbox = document.querySelector('.inbox__content');

            if(drawer) {
              drawer.scrollTop = drawer.scrollHeight;
            } else {
              inbox.scrollTop = inbox.scrollHeight;
            }
          }, 100);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });

    // Mark the thread as read
    const readUser = {
      userSid: SessionStore.userData.sid
    }

    api.put(`/messages/${sid}/read`, readUser)
      .then(response => {
        SessionStore.getUnreadCount();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Create a thread
  createThread: action(function(data, callback) {
    SessionStore.startBackgroundLoading('CreateThread');

    api.post(`/messages`, data)
      .then(response => {
        SessionStore.finishBackgroundLoading('CreateThread');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Reply to a thread
  replyToThread: action(function(sid, data) {
    SessionStore.startBackgroundLoading('ReplyToThread');

    api.post(`/messages/${sid}/items`, data)
      .then(response => {
        SessionStore.finishBackgroundLoading('ReplyToThread');
        obx.getThread(response.data.messageThreadSid);
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Confirm date
  confirmDate: action(function(sid, data, callback) {
    SessionStore.startBackgroundLoading('ConfirmDate');

    api.put(`/messages/${sid}/confirm`, data)
      .then(response => {
        SessionStore.finishBackgroundLoading('ConfirmDate');
        obx.getThread(sid, true);

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Cancel request/clear schedule dates
  cancelRequest: action(function(sid, datesEl) {
    SessionStore.startBackgroundLoading('DeleteRequest');

    api.delete(`/messages/${sid}/dates`)
      .then(response => {
        if(datesEl) {
          // Fade the request out
          datesEl.className += ' fade-out';

          // Then remove it after the fade
          setTimeout(function(){
            datesEl.remove();
          }, 250);
        }

        SessionStore.finishBackgroundLoading('DeleteRequest');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/MessageStore.js